export default __webpack_public_path__ + "static/media/notifications_16.96561622.png";